import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GetItemManagerRp"*/ './lazyIndex'),
    { name: 'GetItemManagerRp' }
);

export const lazyInitializeGetItemManagerForRP: LazyImport<
    typeof lazyIndex.initializeGetItemManagerForRP,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.initializeGetItemManagerForRP);
